var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineSearchCircle54Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 27C0 12.0883 12.0883 0 27 0V0C41.9117 0 54 12.0883 54 27V27C54 41.9117 41.9117 54 27 54V54C12.0883 54 0 41.9117 0 27V27Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 29H29.71L29.43 28.73C30.41 27.59 31 26.11 31 24.5C31 20.91 28.09 18 24.5 18C20.91 18 18 20.91 18 24.5C18 28.09 20.91 31 24.5 31C26.11 31 27.59 30.41 28.73 29.43L29 29.71V30.5L34 35.49L35.49 34L30.5 29V29ZM24.5 29C22.01 29 20 26.99 20 24.5C20 22.01 22.01 20 24.5 20C26.99 20 29 22.01 29 24.5C29 26.99 26.99 29 24.5 29Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineSearchCircle54Px);
export default __webpack_public_path__ + "static/media/ic_outline-search_circle-54px.1386a6b84cd87803e8e9aca6f4a1e8d0.svg";
export { ForwardRef as ReactComponent };